<template>
	<div class="content">
		<FadeTransition
			:duration="200"
			mode="out-in"
		>
			<!-- your content here -->

			<router-view></router-view>
		</FadeTransition>
	</div>
</template>
<script>
import { FadeTransition } from 'vue2-transitions';
import BaseButton from '../BaseButton.vue';
export default {
	components: {
		FadeTransition,
		BaseButton
	}
};
</script>
<style></style>
